import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';

const LazyViewServiceTeamMembersDrawer = React.lazy(
	() => import('../components/ViewServiceTeamMembersDrawer')
);

export const ViewServiceTeamMembersDrawer: React.FC<
	OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:service-team:view-members'>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	const { serviceTeamRID } = options || {};

	if (!serviceTeamRID) {
		console.error('ViewServiceTeamMembersDrawer: serviceTeamRID is required');
		cancelInteraction?.();
		return null;
	}
	return (
		<React.Suspense
			fallback={<div data-testid="view-service-team-members-drawer-loading" />}
		>
			<LazyViewServiceTeamMembersDrawer
				initialParameters={{
					serviceTeamRID,
					piral,
					cancelInteraction,
					completeInteraction,
				}}
			/>
		</React.Suspense>
	);
};
